import React from "react";
import brickMosaicIcon from "./typeofgift-brickmosaic.png";
import giftCardIcon from "./typeofgift-giftcard.png";
import type { GiftType } from "@brickme/project-core/src/model/project.ts";

type GiftTypeSelectionStepProps = {
	readonly onGiftTypeSelect: (giftType: GiftType) => void;
};

export default function GiftTypeSelectionStep({
	onGiftTypeSelect,
}: GiftTypeSelectionStepProps) {
	return (
		<div className="get-started-step">
			<div className="get-started-content">
				<h1 className="get-started-title">What type of gift?</h1>

				<div className="gift-options">
					<button
						className="gift-option"
						onClick={() => onGiftTypeSelect("brick_mosaic")}
						type="button"
					>
						<div className="gift-option-content">
							<div className="gift-icon-section">
								<div className="gift-icon">
									<img src={brickMosaicIcon} alt="Brick mosaic" />
								</div>
							</div>
							<div className="gift-header-section">
								<h2>Brick mosaic</h2>
							</div>
							<div className="gift-text-section">
								<p>Create a custom brick mosaic design</p>
							</div>
						</div>
					</button>

					<button
						className="gift-option"
						onClick={() => onGiftTypeSelect("gift_card")}
						type="button"
					>
						<div className="gift-option-content">
							<div className="gift-icon-section">
								<div className="gift-icon">
									<img src={giftCardIcon} alt="Gift card" />
								</div>
							</div>
							<div className="gift-header-section">
								<h2>Gift card</h2>
							</div>
							<div className="gift-text-section">
								<p>Let them choose their own design</p>
							</div>
						</div>
					</button>
				</div>
			</div>
		</div>
	);
}
